<template>
  <dl
    class="admin-metric-strip"
    :aria-busy="loading ? 'true' : 'false'"
  >
    <div
      v-for="item in items"
      :key="item.label"
      class="admin-metric-strip__item"
    >
      <dt>{{ item.label }}</dt>
      <dd>
        <router-link
          v-if="item.to && !loading"
          :to="item.to"
        >
          {{ item.value }}
        </router-link>
        <span v-else>{{ loading ? '…' : item.value }}</span>
      </dd>
      <small v-if="item.helper || item.caption">{{ item.helper || item.caption }}</small>
      <small v-if="item.badge">{{ item.badge }}</small>
      <small
        v-if="item.comparison"
        :class="item.comparisonClass"
      >{{ item.comparison }}</small>
    </div>
  </dl>
</template>

<script>
export default {
  name: 'AdminMetricStrip',
  props: {
    items: { type: Array, required: true },
    loading: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.admin-metric-strip { display: grid; grid-template-columns: repeat(auto-fit, minmax(155px, 1fr)); margin: 0; border-block: 1px solid #dce0e5; }
.admin-metric-strip__item { min-width: 0; padding: 12px 16px; }
.admin-metric-strip[aria-busy="true"] small { visibility: hidden; }
dt { font-size: 12px; color: #545965; }
dd { margin: 5px 0 0; font-size: 23px; line-height: 1.3; font-weight: 700; color: var(--admin-text, #252930); overflow-wrap: anywhere; }
small { display: block; margin-top: 4px; font-size: 12px; color: #545965; }
.theme--dark .admin-metric-strip { border-color: #474b54; }
.theme--dark dt, .theme--dark small { color: #c3c7cf; }
@media (max-width: 600px) { .admin-metric-strip { grid-template-columns: repeat(2, minmax(0, 1fr)); } .admin-metric-strip__item { padding: 10px; } dd { font-size: 20px; } }
</style>
